module.exports = __webpack_public_path__ + "img/empty-users.4d585fa3.svg";